import React, { useCallback, useEffect, useState, memo } from "react";
import { useDispatch } from "react-redux";
import API from "Utils/api";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

import {
  ModalBackgroundStyled,
  ModalStyled,
} from "../../common/ModalComponent/styles";
import { closeAnyModal } from "Slices/modals";

import {
  VersionsModalLineStyled,
  VersionsModalContentStyled,
  VersionsModalHeaderStyled,
  VersionsModalCopyBtnStyled,
  VersionsModalCloseIconStyled,
} from "./styles";

const APP_VERSION_LONG = window._env_.APP_VERSION_LONG || "";
const REACT_APP_CYNGN_INSIGHT_VERSION =
  window._env_.REACT_APP_CYNGN_INSIGHT_VERSION || "v3.4";

const VersionsModalLine = ({ name, version }) => {
  return (
    <CopyToClipboard
      text={`${name}: ${version}`}
      onCopy={() => toast.success("Copied to Clipboard!")}
    >
      <VersionsModalLineStyled>
        {name}:<strong>{version}</strong>
      </VersionsModalLineStyled>
    </CopyToClipboard>
  );
};

export const VersionsModal = memo(() => {
  const dispatch = useDispatch();

  const [cloudCore, setCloudCore] = useState("");

  const handleCloseAction = useCallback(() => {
    dispatch(closeAnyModal());
  }, []);

  const getVideoserverCloudCore = async () => {
    try {
      const response = await API.get("livez");
      if (response.data) {
        setCloudCore(response.data.APP_VERSION);
      }
    } catch (error) {
      if (error?.response?.data?.detail) {
        toast.error(error.response.data.detail);
        return;
      }
      toast.error("Something went wrong with getVideoserverCloudCore");
    }
  };

  useEffect(() => {
    getVideoserverCloudCore();
  }, []);

  return (
    <ModalStyled>
      <ModalBackgroundStyled onClick={handleCloseAction} />
      <VersionsModalContentStyled>
        <VersionsModalCloseIconStyled onClick={handleCloseAction} />
        <VersionsModalHeaderStyled>Versions</VersionsModalHeaderStyled>
        <VersionsModalLine
          name="Cyngn Insight"
          version={REACT_APP_CYNGN_INSIGHT_VERSION}
        />
        <CopyToClipboard
          text={`Versions: 
Cyngn Insight: ${REACT_APP_CYNGN_INSIGHT_VERSION}
Cloud Core: ${cloudCore}
Frontend: ${APP_VERSION_LONG}
          `}
          onCopy={() => toast.success("Copied to Clipboard!")}
        >
          <VersionsModalCopyBtnStyled
            type={"primary"}
            width={60}
            fontSize={14}
            marginBottom={0}
          >
            Copy to Clipboard
          </VersionsModalCopyBtnStyled>
        </CopyToClipboard>
      </VersionsModalContentStyled>
    </ModalStyled>
  );
});
